<template>
  <div class="my_certification">
    <div class="certification_head_title">
      <!-- <van-nav-bar title="认证类型" left-arrow @click-left="onClickLeft" /> -->
      <van-nav-bar
        :title="$t('message.my.signingCertification')"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>

    <div class="select">{{ $t('message.news.pleaseType') }}</div>

    <!-- 选择类型 -->
    <div class="selectType">
      <div class="personage" @click="clickTo(1)">
        <div class="personage_txt">
          <!-- <div class="personage_head">个人认证</div> -->
          <div class="personage_head">{{ $t('message.news.personalCertification') }}</div>
          <!-- <div>个人用户开通影像投稿功能</div>
          <div>提供身份证/护照信息进行实名认证</div> -->
          <div>{{ $t('message.news.realnameTip') }}</div>
          <div>{{ $t('message.news.provideAuthentication') }}</div>
        </div>
        <div class="personage_img">
          <img src="../../../../static/image/2423.png" alt="" />
        </div>
      </div>

      <div class="enterprise" @click="clickTo(2)">
        <div class="enterprise_txt">
          <!-- <div class="enterprise_head">企业认证/组织认证</div>
          <div>企业/组织/机构用户开通影像投稿功能</div>
          <div>提供组织信息进行实名认证</div> -->
          <div class="enterprise_head">{{ $t('message.news.enterpriseCertification') }}</div>
          <div>{{ $t('message.news.enterpriseFunction') }}</div>
          <div>{{ $t('message.news.provideOrganization') }}</div>
        </div>
        <div class="enterprise_img">
          <img src="../../../../static/image/2422.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from '@/utils/cookie'
import { selectCertificationInfo } from '@/api/journalism.js'
import { Toast } from 'vant'
export default {
  components: {},
  data() {
    return {
      auditStatus: 0
    }
  },
  computed: {},
  watch: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    async clickTo(index) {
      let query = {
        auditStatus: '',
        mobile: '',
        nickName: '',
        order: '',
        pageNum: 1,
        pageSize: 10,
        realName: '',
        userId: getCookie('userId')
      }
      const { data: res } = await selectCertificationInfo(query)
      if (res.resultCode == 200) {
        if (res.data.list[0]) {
          // 认证状态（1:已提交;2：不通过，3：通过）
          this.auditStatus = res.data.list[0].auditStatus
          if (res.data.list[0].auditStatus == 1) {
            return Toast('您的认证正在审核中')
          } else if (res.data.list[0].auditStatus == 2) {
            if (index == 1) {
              this.$router.push({
                path: '/user/personalCertificate',
                query: {
                  state: '2'
                }
              })
            } else if (index == 2) {
              this.$router.push({
                path: '/user/enterpriseCertification',
                query: {
                  state: '2'
                }
              })
            }
          } else if (res.data.list[0].auditStatus == 3) {
            return Toast('您的认证已通过，请勿重复点击认证')
          }
        } else {
          if (index == 1) {
            this.$router.push({
              path: '/user/personalCertificate'
            })
          } else if (index == 2) {
            this.$router.push({
              path: '/user/enterpriseCertification'
            })
          }
        }
      }

      // const { data: res } = await selectIsAuthentication({
      //   appId: getCookie('userId')
      // })
      // if (index == 1) {
      //   if (res.data == 1 || res.data == 4) {
      //     this.$router.push({
      //       path: '/user/personalCertificate'
      //     })
      //   } else if (res.data == 2) {
      //     return Toast('您的个人认证正在审核中，请耐心等待')
      //   } else if (res.data == 3) {
      //     return Toast('您已成功认证，请勿重复进行认证')
      //   }
      // } else if (index == 2) {
      //   if (res.data == 1 || res.data == 4) {
      //     this.$router.push({
      //       path: '/user/enterpriseCertification'
      //     })
      //   } else if (res.data == 2) {
      //     return Toast('您的个人认证正在审核中，请耐心等待')
      //   } else if (res.data == 3) {
      //     return Toast('您已成功认证，请勿重复进行认证')
      //   }
      // }
    }
  },
  created() {},
  mounted() {}
}
</script>
<style scoped lang="less">
.my_certification {
  .certification_head_title {
    font-size: 16px;
    color: #151515;

    /deep/.van-icon {
      color: #515151;
    }
  }

  .select {
    height: 93px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #151515;
    font-size: 20px;
    font-weight: 700;
  }

  .selectType {
    padding: 0 15px;
    .personage {
      min-height: 135px;
      background-color: #fd4d4c;
      margin-bottom: 16px;
      border-radius: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      .personage_txt {
        color: #fff;
        font-size: 13px;
        margin-bottom: 10px;
        .personage_head {
          font-size: 20px;
          font-weight: 600;
          margin: 29px 0 13px 0;
        }
      }
      .personage_img {
        height: 100%;
        display: flex;
        align-items: center;
        img {
          width: 77px;
          height: 77px;
          border-radius: 50%;
        }
      }
    }
    .enterprise {
      min-height: 135px;
      background-color: #0ea0f1;
      border-radius: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      .enterprise_txt {
        color: #fff;
        font-size: 13px;
        margin-bottom: 10px;
        .enterprise_head {
          font-size: 20px;
          font-weight: 600;
          margin: 29px 0 13px 0;
        }
      }
      .enterprise_img {
        height: 100%;
        display: flex;
        align-items: center;
        img {
          width: 77px;
          height: 77px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
